import { render, staticRenderFns } from "./DefaultAdminLogin.vue?vue&type=template&id=4fdc1af6"
import script from "./DefaultAdminLogin.vue?vue&type=script&lang=js"
export * from "./DefaultAdminLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports